<template>
  <div
    class="white-container--with-padding"
    :class="[
      {
        'white-container--with-header': title,
        'white-container--with-small-padding': title && smallPadding,
        'white-container--with-header-no-separator': hideHeaderSeparator,
        [`white-container--${type}`]: type,
        [`white-container--${headerSize}`]: headerSize,
        'white-container--square': withoutRadius,
      },
    ]"
  >
    <div v-if="hasHeaderSlot">
      <slot name="header" />
    </div>

    <div
      :class="['header', headerClass]"
      v-if="(title && !hasHeaderSlot)"
    >
      <div
        :class="[
          'header-col',
          `white-container-header--${titleSize}`
        ]"
      >
        <div
          v-if="!!this.$slots['header-prefix']"
          class="header-prefix"
        >
          <slot name="header-prefix" />
        </div>

        <div :class="{ 'header-with-image': !compactHeading }">
          <img
            v-if="titleIcon && !compactHeading"
            :src="titleIcon"
          >
          <Heading
            class="heading--semibold my-0"
            kind="h2"
            :type="compactHeading ? 'h4' : 'h2'"
          >
            {{ title }}
          </Heading>
        </div>

        <div
          v-if="!!this.$slots['header-extra-content']"
          class="header-extra-content"
        >
          <slot name="header-extra-content" />
        </div>
      </div>

      <div
        v-if="!!this.$slots['header-center']"
        class="header-col-center"
      >
        <slot name="header-center" />
      </div>

      <div
        v-if="!!this.$slots['header-right']"
        class="header-col-right"
      >
        <slot name="header-right" />
      </div>
    </div>
    <slot />
  </div>
</template>

<script>
export default {
  name: 'WhiteContainer',
  props: {
    title: {
      type: String,
    },
    titleSize: {
      type: String,
      default: 'normal',
    },
    titleIcon: {
      type: String,
    },
    headerClass: {
      type: String,
    },
    hideHeaderSeparator: {
      type: Boolean,
    },
    type: {
      type: String,
    },
    headerSize: {
      type: String,
      default: 'normal',
    },
    smallPadding: {
      type: Boolean,
    },
    compactHeading: {
      type: Boolean,
      default: false,
    },
    withoutRadius: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    hasHeaderSlot() {
      return !!this.$slots.header;
    },
  },
};
</script>

<style lang="scss" scoped>
.white-container--with-padding {
  position: relative;
}

.white-container--with-header {
  @include media('>sm') {
    padding-left: 39px;
    padding-right: 39px;
  }
}

.white-container--with-header-no-separator {
  .header {
    margin-bottom: 25px;
    border-bottom: none;
  }
}

.white-container--without-separator {
  .header {
    border-bottom: none;
    padding-bottom: 0;
    margin-bottom: 32px;
  }
}

.white-container--shrink {
  .header {
    margin-bottom: 0;
    padding: 6px 0 14px;
  }
}

.white-container--success {
  background: #f3fcf8;
  border: 1px solid #c0ecd7;
}

.white-container--disabled {
  background: $white;
  border-radius: 16px;
  box-shadow: $--shadow-300;
  padding: 8px 24px 32px;
}

.header {
  margin: 0 0 50px;
  padding: 6px 0 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
  border-bottom: 1px solid $--color-light-blue-new;

  @media only screen and (max-width: $--sm - 1px) {
    row-gap: 24px;
  }

  &.header--sm-margin {
    @media only screen and (max-width: $--sm - 1px) {
      margin-bottom: 8px;
    }
  }
}

.header-prefix {
  margin-right: -8px;
}

.header-col,
.header-col-center,
.header-col-right,
.header-with-image {
  @include media('<sm') {
    width: 100%;
  }
}

.header-col,
.header-with-image {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 24px;

  @include media('<sm') {
    flex-wrap: wrap;
  }
}

.header-with-image {
  flex-wrap: nowrap;
  position: relative;

  &:has(> img) {
    padding-left: 62px;
  }

  > h2 {
    font-size: rem(22px);
    font-weight: 600;
    margin-bottom: 0;
  }

  > img {
    position: absolute;
    left: 0;
    max-height: 48px;
    width: 48px;
  }
}

.header-col-center {
  @include media('>md') {
    text-align: center;
  }
}

.header-col-right {
  @include media('>sm') {
    margin-top: 0;
    text-align: right;
  }
}

.header-extra-content {
  display: inline-flex;
  align-items: center;
  gap: 12px;
}

.white-container-header--small {
  font-size: 130%;
}

.white-container--with-small-padding {
  padding: 24px 16px;
}

.white-container--square {
  border-radius: 0;
}

.white-container--with-extra-header-content {
  .header-extra-content {
    @media only screen and (max-width: $--xs - 1px) {
      flex-wrap: wrap;
    }
  }
}
</style>
